import { DocumentMessages } from "@/messages/document-messages";
import { DocumentType } from "@/types/document.types";
import { SelectData } from "@/types/form.types";

export const MIN_RG_LENGTH = 9;
export const MAX_RG_LENGTH = 10;
export const RG_REGEX = /^[\w.-]+$/;
export const CPF_LENGTH = 11;
export const CPF_REGEXP = /^(\d)\1{10}$/;
export const FIRST_CPF_VERIFICATION_DIGIT_INDEX = 9;
export const SECOND_CPF_VERIFICATION_DIGIT_INDEX = 10;
export const MIN_CNPJ_LENGTH = 14;
export const NUM_DV = 2;
export const POSITION_DV_CALCULATION_START = 7;
export const DV_MOD_THRESHOLD = 2;
export const DV_MOD_RESULT = 11;
export const CEP_LENGHT = 8;

export const STATE_UF_TRANSLATIONS: Record<string, string> = {
  AC: "Acre",
  AL: "Alagoas",
  AM: "Amazonas",
  AP: "Amapá",
  BA: "Bahia",
  CE: "Ceará",
  DF: "Distrito Federal",
  ES: "Espírito Santo",
  GO: "Goiás",
  MA: "Maranhão",
  MG: "Minas Gerais",
  MS: "Mato Grosso do Sul",
  MT: "Mato Grosso",
  PA: "Pará",
  PB: "Paraíba",
  PE: "Pernambuco",
  PI: "Piauí",
  PR: "Paraná",
  RJ: "Rio de Janeiro",
  RN: "Rio Grande do Norte",
  RO: "Rondônia",
  RR: "Roraima",
  RS: "Rio Grande do Sul",
  SC: "Santa Catarina",
  SE: "Sergipe",
  SP: "São Paulo",
  TO: "Tocantins",
};

export const ADDRESS_MASK = (value: string): string => {
  let mask = "";
  switch (value) {
    case "BRASIL":
      mask = "99999-999";
      break;

    default:
      mask = "";
      break;
  }

  return mask;
};

export const DOCUMENT_TYPE_TRANSLATION = (
  messages: DocumentMessages
): Record<DocumentType, string> => {
  return {
    [DocumentType.RG]: messages.rgOption,
    [DocumentType.CPF]: messages.cpfOption,
    [DocumentType.CNPJ]: messages.cnpjOption,
    [DocumentType.UNDEFINED]: "",
  };
};

export const DOCUMENT_TYPE_OPTIONS = (messages: DocumentMessages): SelectData<DocumentType>[] => {
  const labels = DOCUMENT_TYPE_TRANSLATION(messages);

  return [
    {
      value: DocumentType.CNPJ,
      label: labels[DocumentType.CNPJ],
    },
    {
      value: DocumentType.CPF,
      label: labels[DocumentType.CPF],
    },
  ];
};
